
export const size = {
  mobile: '770px',
  tabletS: '1023px',
  tabletM: '1220px',
  tabletL: `1280px`,
};


export const colors = {

  slate200: '#e2e8f0',
  slate300: '#cad5e2',
  slate400: '#90a1b9',
  slate500: '#62748e',
  slate600: '#45556c',
  slate700: '#314158',
  slate800: '#1d293d',


  navy900: '#0d1526',
  navy800: '#121a2a',
  navy700: '#131b2d',
  navy600: '#1e283d',


  blue500: '#2b7fff',


  green500: '#00bc7d',
  green400: '#34d399',
  red500: '#fb2c36',
  red400: '#ff6467',
};

export const gradients = {

  pageBg: `linear-gradient(180deg, ${colors.navy600} 0%, ${colors.navy800} 100%)`,

  accentSoft: 'linear-gradient(135deg, rgba(43,127,255,0.2) 0%, rgba(43,127,255,0) 100%)',
};

export const semantic = {
  bg: colors.navy900,
  surface: colors.navy700,
  surfaceElevated: colors.slate800,
  border: colors.slate700,
  borderMuted: colors.slate600,
  text: {
    bright: colors.slate200,
    primary: colors.slate300,
    secondary: colors.slate400,
    muted: colors.slate500,
  },
  accent: colors.blue500,
  status: {
    online: colors.green500,
    onlineGlow: colors.green400,
    fault: colors.red500,
    faultGlow: colors.red400,
    offline: colors.slate500,
    info: colors.blue500,
  },
};


export const graph = {
  heater: '#f97316',
  enclosure: '#00bc7d',
  outside: '#2b7fff',
  axis: '#666666',
  threshold: '#5b9bd5',
};




export const statCard = {
  bg: 'var(--stat-card-bg)',
  border: 'var(--stat-card-border)',
  value: 'var(--stat-card-value)',
  label: 'var(--stat-card-label)',
  gaugeTrack: 'var(--stat-gauge-track)',
  gaugeFill: 'var(--stat-gauge-fill)',
  totalBg: 'var(--stat-total-bg)',
  totalBorder: 'var(--stat-total-border)',
  totalLabel: 'var(--stat-total-label)',
  totalValue: 'var(--stat-total-value)',
};

export const radii = {
  sm: '8px',
  md: '14px',
  lg: '16px',
  pill: '9999px',
};

export const spacing = {
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '20px',
};

export const fontSizes = {
  xxs: '9px',
  xs: '10px',
  sm: '11px',
  base: '12px',
  md: '14px',
  lg: '21px',
};

export const fonts = {
  base: "'Inter', sans-serif",
  mono: "'Consolas', monospace",
};

export const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
};
